import React, { useEffect } from 'react';
import SwaggerUI, { SwaggerUIOptions } from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';
// @ts-ignore
import { SwaggerUIKongTheme } from 'swagger-ui-kong-theme';
import useYamlParse from '../hooks/useYamlParse';

interface Language {
  prismLanguage: string;
  target: string;
  client?: string;
}

interface SwaggerUIOptionsType extends SwaggerUIOptions {
  theme?: {
    swaggerAbsoluteTop?: string;
    hasSidebar?: boolean;
    languages?: Language[];
  };
}

const swaggerUIOptions: SwaggerUIOptionsType = {
  dom_id: '#ui-wrapper',
  docExpansion: 'list',
  deepLinking: true,
  filter: true,
  // @ts-ignore
  presets: [SwaggerUI.presets.apis, SwaggerUI.SwaggerUIStandalonePreset],
  // @ts-ignore
  plugins: [SwaggerUIKongTheme, SwaggerUI.plugins.DownloadUrl],
  layout: 'KongLayout',
  theme: {
    swaggerAbsoluteTop: '0px',
    hasSidebar: true,
    languages: [
      {
        prismLanguage: 'bash',
        target: 'shell',
        client: 'curl',
      },
      {
        prismLanguage: 'javascript',
        target: 'javascript',
      },
      {
        prismLanguage: 'python',
        target: 'python',
      },
      {
        prismLanguage: 'ruby',
        target: 'ruby',
      },
    ],
  },
};

function SwaggerLoader({ url }: { url: string }) {
  const getSpec = useYamlParse();

  useEffect(() => {
    (async () => {
      const spec = await getSpec(url);

      SwaggerUI({
        ...swaggerUIOptions,
        spec,
      });
    })();
  }, [useYamlParse, url]);

  return (
    <>
      <div id="ui-wrapper" />
    </>
  );
}

export default React.memo(SwaggerLoader);
